import { useEffect, useRef } from "react";
import { isMobile, scroll2Top } from "../utils/utils";
import InfoBeneficiaryStep0Bloc from "../blocs/info-beneficiary/InfoBeneficiaryStep0Bloc";

export default function InfoBeneficiaryStep0Page() {
  const pageGapRef = useRef<null | HTMLDivElement>(null);
  useEffect(() => {
    if (isMobile()) {
      pageGapRef.current?.scrollIntoView() 
    } else {
      scroll2Top();
    }
  }, []);

    return (
   
      <div className="entreprise-container">
        
        <h1 className="title ml-lg-desktop mb-sm">Souhaitez vous ajouter des ayants droit ?</h1>
        <div ref={pageGapRef} className="page-gap" />
        <div className="page-content flex-grid m-lg-desktop">
            <InfoBeneficiaryStep0Bloc/>
        </div>
      </div>
   
    )

}